import React from 'react';
import { Box } from '@mui/material';
import { TimeperiodSelect } from 'app/components/ReusableUIComponents/HighLevelComponents/TimePeriodSelectMAIQ';

import { renderComponentEnum } from 'app/pages/SalesPortalPage/LayoutV1/data/type';

import {
  FormControlLabel,
  FormControl,
  InputLabel,
  Switch,
  Select,
  MenuItem,
} from '@mui/material';

type SalesDemoToolbarProps = {
  mockApiFlag;
  mysqlFlag;
  handleToggleMockData;
  handleToggleMysql;
  timeperiod;
  selectedTimeperiod;
  handleClickChangeTimeperiod;
  renderComponent;
};

export const SalesDemoToolbar = ({
  mockApiFlag,
  mysqlFlag,
  handleToggleMockData,
  handleToggleMysql,
  timeperiod,
  selectedTimeperiod,
  handleClickChangeTimeperiod,
  renderComponent,
}: SalesDemoToolbarProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        marginLeft: 'auto',
        alignItems: 'flex-start',
      }}
    >
      {/* <FormControlLabel
        control={
          <Switch
            checked={mockApiFlag}
            onChange={handleToggleMockData}
            name="useMockData"
            color="primary"
          />
        }
        label="Use Mock API"
      />
      <FormControlLabel
        control={
          <Switch
            checked={mysqlFlag}
            onChange={handleToggleMysql}
            name="useMYSQL"
            color="primary"
          />
        }
        label="Use mysql"
      /> */}
      <TimeperiodSelect
        timeperiod={timeperiod}
        selectedTimeperiod={selectedTimeperiod}
        handleClickChangeTimeperiod={handleClickChangeTimeperiod}
        renderComponent={renderComponent}
      />
    </Box>
  );
};
